import React from 'react';
import { func, instanceOf } from 'prop-types';
import classnames from 'classnames';
import TextField from '../textfield/textfield';

class DatetimeInput extends React.PureComponent {
  render() {
    const {
      onChange,
      min,
      max,
      className,
      defaultValue,
      value,
      ...props
    } = this.props;

    const dateToString = (dateFrom) => {
      const date = new Date(dateFrom.getTime());
      date.setMinutes(date.getMinutes() - date.getTimezoneOffset());

      return date.toISOString().substr(0, 19);
    };

    return (
      <TextField
        className={classnames('mdc-text-field--inline mdc-input-datetime', className)}
        onChange={({ target: { value } }) => {
          const date = new Date(value);

          if (!Number.isNaN(date.getTime())) {
            onChange(date);
          }
        }}
        type="datetime-local"
        min={min && dateToString(min)}
        max={max && dateToString(max)}
        defaultValue={defaultValue && dateToString(defaultValue)}
        value={value && dateToString(value)}
        {...props}
      />
    );
  }
}

DatetimeInput.propTypes = {
  onChange: func,
  min: instanceOf(Date),
  max: instanceOf(Date),
  defaultValue: instanceOf(Date),
  value: instanceOf(Date),
};

DatetimeInput.defaultProps = {
  onChange: () => null,
  min: undefined,
  max: undefined,
  defaultValue: undefined,
  value: undefined,
};

export default DatetimeInput;
